/**
 * Vite-native view module registry for menu-driven routes (used by PresetLoader.GetModuleBasedRoute).
 * Route names that show the right-side filter bar (used by PresetLoader.navigationGuard).
 */

const adminViews = import.meta.glob("@/admin/views/*.vue");
const assetViews = import.meta.glob("@/asset/views/*.vue");
const crmViews = import.meta.glob("@/crm/views/*.vue");
const ticketViews = import.meta.glob("@/ticket/views/*.vue");
const applicationViews = import.meta.glob("@/application/views/*.vue");
const calendarViews = import.meta.glob("@/calendar/views/*.vue");
const alertViews = import.meta.glob("@/alert/views/*.vue");
const reportViews = import.meta.glob("@/report/views/*.vue");
const billingViews = import.meta.glob("@/billing/views/*.vue");
const integrationViews = import.meta.glob("@/integration/views/*.vue");
const documentViews = import.meta.glob("@/document/views/*.vue");
const formViews = import.meta.glob("@/form/views/*.vue");

export const moduleRegistry: Record<string, Record<string, any>> = {
  admin: adminViews,
  asset: assetViews,
  crm: crmViews,
  ticket: ticketViews,
  application: applicationViews,
  calendar: calendarViews,
  alert: alertViews,
  report: reportViews,
  billing: billingViews,
  integration: integrationViews,
  document: documentViews,
  form: formViews,
};

export const routesWithFilters = [
  "ticket-list",
  "product-list",
  "bundle-list",
  "invoice-list",
  "alerts",
  "asset-list",
  "calendar",
  "device-list",
  "asset-requisition-approval-list",
  "asset-requisition-purchase-order-list",
  "contact-list",
  "technician-list",
  "check-list",
  "ticket-detail",
  "ticket-detail-popout",
] as const;
